export default __webpack_public_path__ + "static/media/3.a5a582d5.png";